import React, { Component } from 'react'

export default class Tips extends Component {
  render() {
    return (
      <div style={{ width: 315 }}>
        <label>
          Collect Tips
        </label>
        <div
          onClick={() => this.props.toggle('collectTips')}
          data-tip={ this.props.collectTips ? 'On' : 'Off' }
          className={
            this.props.collectTips
            ? 'toggle-button on'
            : 'toggle-button off'
          }>
          <div className='toggle-switch'/>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Settings/Tips.jsx